module.exports = __webpack_public_path__ + "img/one.8ce19bc5.jpg";